import Marquee from "react-fast-marquee";
import { SITE } from "@/data/content";

const items = ["Creative Editor", "Visual Designer", "AI Content Creator", "Storyteller", "Colorist"];

export default function EditorialMarquee() {
  return (
    <div data-testid="editorial-marquee" className="relative py-12 md:py-16 border-y border-white/[0.06] bg-void overflow-hidden">
      <Marquee speed={30} gradient={false} pauseOnHover>
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display italic text-4xl md:text-6xl font-bold text-stroke mx-6 md:mx-10 whitespace-nowrap hover:text-stroke-gold transition-all duration-500">
              {item}
            </span>
            <span className="text-gold text-xl md:text-2xl mx-2">✦</span>
          </span>
        ))}
      </Marquee>
      <p className="sr-only">{SITE.tagline}</p>
    </div>
  );
}
